<template>
  <div class="allergeni-manager">
    <div class="header">
      <button class="btn-back" @click="$router.push({ name: 'Gestionale' })">
        <i class="fas fa-chevron-left"></i> {{ $t('indietro') || 'Gestionale' }}
      </button>
      <h2>{{ $t('gestione_allergeni') || 'Gestione Allergeni' }}</h2>
    </div>

    <div class="content-card">
      <div class="settings-section">
        <h3>{{ $t('impostazioni') || 'Impostazioni' }}</h3>
        <div class="language-selection">
          <label>{{ $t('seleziona_lingue') || 'Seleziona Lingue' }}:</label>
          <div class="checkbox-group">
            <label><input type="checkbox" v-model="selectedLangs" value="it"> Italiano</label>
            <label><input type="checkbox" v-model="selectedLangs" value="en"> English</label>
            <label><input type="checkbox" v-model="selectedLangs" value="es"> Español</label>
          </div>
        </div>
        
        <div class="actions">
          <button 
            class="btn-generate" 
            :disabled="loading || selectedDishes.length === 0 || selectedLangs.length === 0"
            @click="startGeneration"
          >
            <i class="fas" :class="loading ? 'fa-spinner fa-spin' : 'fa-magic'"></i>
            {{ loading ? ($t('generazione_in_corso') || 'Generazione...') : ($t('genera_allergeni') || 'Genera Allergeni AI') }}
          </button>
        </div>
      </div>

      <div class="selection-section">
        <div class="selection-header">
          <h3>{{ $t('seleziona_piatti') || 'Seleziona Piatti' }} ({{ selectedDishes.length }})</h3>
          <div class="selection-controls">
            <button class="btn-link" @click="selectAll">{{ $t('seleziona_tutti') || 'Seleziona Tutti' }}</button>
            <button class="btn-link" @click="selectNone">{{ $t('deseleziona_tutti') || 'Deseleziona Tutti' }}</button>
          </div>
        </div>

        <div class="dish-list">
          <div v-for="category in categories" :key="category.id" class="category-group">
            <template v-if="getDishesByCategory(category.id).length > 0">
              <h4 class="category-title">{{ $t(category.label) }}</h4>
              <div class="dish-grid">
                <div 
                  v-for="dish in getDishesByCategory(category.id)" 
                  :key="dish.nome" 
                  class="dish-item"
                  :class="{ selected: selectedDishes.includes(dish.nome) }"
                  @click="toggleDishSelection(dish.nome)"
                >
                  <div class="checkbox-custom">
                    <i v-if="selectedDishes.includes(dish.nome)" class="fas fa-check"></i>
                  </div>
                  <div class="dish-name">{{ dish.nome }}</div>
                  <div class="dish-status" v-if="dish.allergeni">
                    <i class="fas fa-biohazard" title="Allergeni presenti"></i>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading Overlay -->
    <div v-if="loading" class="overlay">
      <div class="loader">
        <i class="fas fa-spinner fa-spin"></i>
        <p>{{ $t('elaborazione_ia_in_corso') || 'L\'IA sta analizzando gli ingredienti...' }}</p>
        <p class="subtext">{{ processedCount }} / {{ selectedDishes.length }} {{ $t('completati') || 'completati' }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from "../store/store.js";

export default {
  name: 'Allergeni',
  data() {
    return {
      store,
      piatti: [],
      selectedDishes: [],
      selectedLangs: ['it', 'en', 'es'],
      loading: false,
      processedCount: 0,
      categories: [
        { id: 'antipasti', label: 'nostri_antipasti' },
        { id: 'primi', label: 'nostri_primi' },
        { id: 'secondi', label: 'nostri_secondi' },
        { id: 'contorni', label: 'nostri_contorni' },
        { id: 'pizza', label: 'nostra_pizza' },
        { id: 'sushi', label: 'nostro_sushi' },
        { id: 'dolci', label: 'nostri_dolci' },
        { id: 'frutta', label: 'nostra_frutta' },
        { id: 'amari', label: 'nostri_amari' },
        { id: 'bevande', label: 'nostre_bevande' },
        { id: 'calice', label: 'nostro_calice' }
      ]
    };
  },
  methods: {
    fetchMenu() {
      this.axios.post(this.store.path + 'displayMenu').then((response) => {
        if (response.data.messaggio) {
          this.piatti = response.data.messaggio;
        }
      });
    },
    getDishesByCategory(catId) {
      return this.piatti.filter(p => p.portata === catId);
    },
    toggleDishSelection(dishName) {
      const index = this.selectedDishes.indexOf(dishName);
      if (index === -1) {
        this.selectedDishes.push(dishName);
      } else {
        this.selectedDishes.splice(index, 1);
      }
    },
    selectAll() {
      this.selectedDishes = this.piatti.map(p => p.nome);
    },
    selectNone() {
      this.selectedDishes = [];
    },
    async startGeneration() {
      this.loading = true;
      this.processedCount = 0;
      
      try {
        const response = await this.axios.post(this.store.path + 'generate-allergens', {
          dishes: this.selectedDishes,
          languages: this.selectedLangs
        });
        
        if (response.data.count) {
          alert(`${response.data.count} piatti aggiornati con successo!`);
          this.fetchMenu(); // Rinfresca per vedere lo stato aggiornato
        }
      } catch (error) {
        console.error("Errore generazione allergeni:", error);
        alert("Errore durante la generazione degli allergeni. Riprova.");
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.fetchMenu();
  }
};
</script>

<style scoped>
.allergeni-manager {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Inter', sans-serif;
  color: #2c3e50;
}

.header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
}

.btn-back {
  background: none;
  border: 1px solid #ddd;
  padding: 8px 15px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-back:hover {
  background: #f8f9fa;
  border-color: #ccc;
}

.content-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  padding: 30px;
}

.settings-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 25px;
  border-bottom: 1px solid #eee;
  margin-bottom: 25px;
  gap: 20px;
}

.language-selection label {
  display: block;
  font-weight: 600;
  margin-bottom: 10px;
}

.checkbox-group {
  display: flex;
  gap: 20px;
}

.checkbox-group label {
  font-weight: normal;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.btn-generate {
  background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%);
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 15px rgba(108, 92, 231, 0.3);
}

.btn-generate:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.4);
}

.btn-generate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  filter: grayscale(1);
}

.selection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.btn-link {
  background: none;
  border: none;
  color: #3498db;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
  margin-left: 15px;
}

.btn-link:hover {
  text-decoration: underline;
}

.category-group {
  margin-bottom: 30px;
}

.category-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #7f8c8d;
  margin-bottom: 15px;
  border-left: 4px solid #3498db;
  padding-left: 12px;
}

.dish-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
}

.dish-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid #eee;
  gap: 10px;
  position: relative;
}

.dish-item:hover {
  background: #fff;
  border-color: #3498db;
  transform: translateY(-2px);
}

.dish-item.selected {
  background: #ebf5fb;
  border-color: #3498db;
}

.checkbox-custom {
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}

.selected .checkbox-custom {
  background: #3498db;
  border-color: #3498db;
  color: white;
  font-size: 0.8rem;
}

.dish-name {
  font-size: 0.9rem;
  font-weight: 500;
  flex: 1;
}

.dish-status {
  color: #e67e22;
  font-size: 0.8rem;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.loader {
  text-align: center;
}

.loader i {
  font-size: 3rem;
  color: #6c5ce7;
  margin-bottom: 20px;
}

.loader p {
  font-size: 1.2rem;
  font-weight: 600;
}

.subtext {
  color: #7f8c8d;
  margin-top: 10px;
}

@media (max-width: 600px) {
  .settings-section {
    flex-direction: column;
  }
  .checkbox-group {
    flex-direction: column;
    gap: 10px;
  }
  .btn-generate {
    width: 100%;
  }
}
</style>
